import { AccountSchema } from '../schema/account_schema.js';
import { ServiceBase } from './service_base.js';

/**
 * A service to manage accounts on the server.
 */
class AccountService extends ServiceBase {
  // Sign up the user.
  signup(user) {
    return this.serviceRequest('signup', user);
  }

  // Log in the user.
  login(user) {
    return this.requestPath('/login', user);
  }

  // Log out the user.
  logout() {
    return this.get('/logout');
  }

  // Returns the session info if any.
  identify() {
    return this.serviceRequest('identify');
  }

  // Initiate password recovery for the given email.
  recoverPassword(email) {
    return this.serviceRequest('recover-password', {
      email,
    });
  }

  // Cancel the password recovery.
  cancelPasswordRecovery(hash) {
    return this.serviceRequest('cancel-password-recovery', {
      hash,
    });
  }

  // Check the password recovery hash validity.
  checkPasswordRecoveryHash(hash) {
    return this.serviceRequest(
      'check-password-recovery-hash',
      {
        hash,
      },
      false
    );
  }

  // Reset the password.
  resetPassword(data) {
    return this.serviceRequest('reset-password', data);
  }

  // Send an email to support.
  contactUs({ name, email, subject, message }) {
    return this.requestPath(`/contact-us`, { name, email, subject, message });
  }

  getSchema(data) {
    return AccountSchema[data.action];
  }
}

export { AccountService };
